import React, { useState } from 'react';
import AddNewStudentsFromProgram from './components/add-new-students-from-program';
import TabBar from '../../../../../../component/tab-bar/tab-bar';
import { CourseMetadataType } from '../../../../../../api/types/programs/course/course-metadata.type';
import { FindUser } from '../../../../../find-user-page/find-user';
import { UserType } from '../../../../../../api/types/user/user-type';
import { UserSummaryType } from '../../../../../../api/types/user/user-summary.type';
import globalProgramStore from '../../../../../../stores/program-store';
import globalCourseStore from '../../../../../../stores/global-course-store';
import { addNewStudentsOperation } from '../../../operations/add-new-students-operation';

const tabs = ['סטודנטים מהתכנית בשנת הקורס', 'הוספת סטודנטים מהשלוחה'];

interface AddNewStudentsCourseModel {
  courseMetadata?: CourseMetadataType;
  closeDialog: () => void;
}
const AddNewStudentsCourse: React.FC<AddNewStudentsCourseModel> = ({
  courseMetadata,
  closeDialog,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleOnApprove = async (
    selectedUsers: UserSummaryType[],
    setLoading: (loading: boolean) => void,
  ) => {
    const programId = globalProgramStore.getCurrentId();
    const courseId = globalCourseStore.getCurrentCourse()?.details?.id;
    const selectedUserIds = selectedUsers.map((userItem) => userItem.id);
    await addNewStudentsOperation(
      programId,
      courseId,
      selectedUserIds,
      selectedUsers,
      setLoading,
      closeDialog,
    );
  };

  const pages = [
    <AddNewStudentsFromProgram
      courseMetadata={courseMetadata}
      closeDialog={closeDialog}
    />,
    <FindUser
      onChange={() => {
        //
      }}
      role={UserType.STUDENT}
      onApprove={handleOnApprove}
      displayApprove={true}
    />,
  ];

  return (
    <div>
      <TabBar
        tabs={tabs}
        onClick={(index) => {
          setSelectedIndex(index);
        }}
      ></TabBar>

      <div>{pages[selectedIndex]}</div>
    </div>
  );
};

export default AddNewStudentsCourse;
